import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab15',
  templateUrl: './awsop-lab15.component.html',
  styleUrls: ['./awsop-lab15.component.css']
})
export class AwsopLab15Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab15/awsop-lab15.component.ts